document.addEventListener('DOMContentLoaded', () => {
  const navSection = document.querySelector('.spx-nav-sticky');
  if (!navSection) return;

  const navItems = Array.from(
    navSection.querySelectorAll('.nav-item a[href^="#"]')
  );

  if (navItems.length === 0) return;

  /** @type {{ link: Element; target: HTMLElement }[]} */
  const sections = navItems
    .map((link) => {
      const href = link.getAttribute('href');
      if (!href || href.length < 2) return null;
      const id = href.slice(1);
      const target = document.getElementById(id);
      if (!target) return null;
      return { link, target };
    })
    .filter((item) => item !== null);

  if (sections.length === 0) return;

  const clearActive = () => {
    navSection
      .querySelectorAll('.nav-item--active')
      .forEach((el) => el.classList.remove('nav-item--active'));
  };

  /** @param {Element} link */
  const setActive = (link) => {
    clearActive();
    const item = link.closest('.nav-item');
    if (item) {
      item.classList.add('nav-item--active');
    }
  };

  // 至少 50% 进入视口才视为激活；多段同时满足时取可见比例最高的一段
  const observerOptions = {
    threshold: [0, 0.5, 1],
  };

  const observer = new IntersectionObserver((entries) => {
    const candidates = entries
      .filter((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
    if (!candidates.length) return;
    const top = candidates[0];
    if (!top) return;
    const found = sections.find(({ target }) => target === top.target);
    if (found) setActive(found.link);
  }, observerOptions);

  sections.forEach(({ target }) => observer.observe(target));

  navItems.forEach((link) => {
    link.addEventListener('click', () => {
      setActive(link);
    });
  });
});

